exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".invalid{border:2px solid red}#country-select,#directionalNumber,#type-of-account-select{height:54px}.type-of-account-span{padding:14px 0 14px 24px;font-size:18px}@media (max-width:991px){#country-select,#directionalNumber,#type-of-account-select{height:40.5px!important}.type-of-account-span{padding:10px 0 10px 24px;font-size:14px}}.fake-label{max-width:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e6d004e","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/auth/registry.vue
// module id = 862
// module chunks = 0